/* ==========================================================================
   Image placeholders

   Until the real photography lands, every image slot points at its final,
   descriptive filename (see IMAGE_PROMPTS.md). When a file is missing, the
   <img> is swapped for a dark box that names the file, its aspect ratio and
   its target pixel size - the same element keeps all its classes, so the
   layout renders exactly as it will with the real image. Video posters get
   the same treatment. Loaded in <head> so it catches the earliest errors.

   Delete this file (and its <script> tags) once every image exists.
   ========================================================================== */

(function () {
  'use strict';

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function fileOf(src) {
    try { return decodeURIComponent(String(src || '').split('?')[0].split('/').pop()); }
    catch (e) { return String(src || ''); }
  }

  function ratio(w, h) {
    function gcd(a, b) { return b ? gcd(b, a % b) : a; }
    var g = gcd(w, h) || 1;
    var a = w / g, b = h / g;
    return a > 40 ? (w / h).toFixed(2) + ':1' : a + ':' + b;
  }

  function svg(name, w, h) {
    w = w || 1200; h = h || 1200;
    var side = Math.min(w, h);
    var fs = Math.round(Math.min(side * 0.06, (w * 0.86) / (Math.max(name.length, 8) * 0.56)));
    var line = Math.max(1, Math.round(side * 0.004));
    var s = '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '" viewBox="0 0 ' + w + ' ' + h + '">' +
      '<rect width="' + w + '" height="' + h + '" fill="#1c1d22"/>' +
      '<rect x="' + line * 4 + '" y="' + line * 4 + '" width="' + (w - line * 8) + '" height="' + (h - line * 8) + '" rx="' + line * 6 +
        '" fill="none" stroke="#45484f" stroke-width="' + line + '" stroke-dasharray="' + line * 6 + ' ' + line * 5 + '"/>' +
      '<text x="50%" y="50%" text-anchor="middle" font-family="Archivo, system-ui, sans-serif" font-weight="600" font-size="' + fs +
        '" fill="#a9adb6">' + esc(name) + '</text>' +
      '<text x="50%" y="50%" dy="' + (fs * 1.6) + '" text-anchor="middle" font-family="Archivo, system-ui, sans-serif" font-size="' +
        Math.round(fs * 0.82) + '" fill="#6f737c">' + ratio(w, h) + ' · ' + w + '×' + h + '</text>' +
    '</svg>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(s);
  }

  /* the header/menu logo falls back to a typed wordmark instead of a box */
  function logoFallback(img) {
    var span = document.createElement('span');
    span.className = 'logo__text';
    span.textContent = img.getAttribute('alt') || 'ThePitlane';
    img.replaceWith(span);
  }

  function swap(img) {
    if (img.dataset.ph) return;
    img.dataset.ph = '1';
    if (img.closest && img.closest('.logo')) { logoFallback(img); return; }
    var name = fileOf(img.getAttribute('src'));
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.classList.add('is-placeholder');
    img.src = svg(name, parseInt(img.getAttribute('width'), 10), parseInt(img.getAttribute('height'), 10));
  }

  document.addEventListener('error', function (e) {
    var el = e.target;
    if (el && el.tagName === 'IMG') swap(el);
  }, true);

  function posters() {
    Array.prototype.forEach.call(document.querySelectorAll('video[poster]'), function (video) {
      var src = video.getAttribute('poster');
      if (!src || src.indexOf('data:') === 0) return;
      var probe = new Image();
      probe.onerror = function () {
        var w = parseInt(video.getAttribute('data-ph-width') || video.getAttribute('width'), 10);
        var h = parseInt(video.getAttribute('data-ph-height') || video.getAttribute('height'), 10);
        video.poster = svg(fileOf(src) + ' + ' + fileOf(video.getAttribute('data-src') || video.getAttribute('src')), w, h);
      };
      probe.src = src;
    });
    /* images that failed before this script could listen (rare) */
    Array.prototype.forEach.call(document.images, function (img) {
      if (img.complete && !img.naturalWidth && img.getAttribute('src')) swap(img);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', posters);
  else posters();
}());
